import { Routes, UrlSegment } from '@angular/router';
import { LtiLaunchComponent } from './pages/auth/lti-launch/lti-launch.component';
import { SigninComponent } from './pages/auth/signin/signin.component';
import { EditProfileComponent } from './pages/edit-profile/edit-profile.component';
import { authGuard } from './guards/auth.guard';
import { RootComponent } from './pages/root/root.component';
import { HandleCodeComponent } from './pages/handle-code/handle-code.component';

export const routes: Routes = [
    { path: '', component: RootComponent},
    { path: 'lti-launch', component: LtiLaunchComponent},
    { path: 'signin', component: SigninComponent},
    {
        path: 'admin',
        loadChildren: () =>
          import('./pages/admin/admin.routes')
            .then(m => m.ADMIN_ROUTES)
    },
    {
        path: 'student',
        loadChildren: () =>
          import('./pages/student/student.routes')
            .then(m => m.STUDENT_ROUTES)
    },
    {
        path: 'edit-profile', component: EditProfileComponent, canActivate: [authGuard]
    },
    {
        path: 'take-selfie',
        loadComponent: () =>
          import('./pages/take-selfie/take-selfie.component')
            .then(m => m.TakeSelfieComponent),
        canActivate: [authGuard]
      },
      {
        path: 'selfie-requests/:requestId',
        loadComponent: () =>
          import('./pages/take-selfie/take-selfie.component')
            .then(m => m.TakeSelfieComponent),
        canActivate: [authGuard]
      },
      {
      matcher: (url) => {
        if (url.length  && url[0].path.match(/^[A-Z0-9]{6,10}$/gm)) {
          return {consumed: url, posParams: {code: new UrlSegment(url[0].path, {})}};
        }
        return null;
      },
      component: HandleCodeComponent
    }


];
